import { createRequestActions, RequestType } from 'store/utils';
import { ICreateDealTypePayload } from 'modules/settings/submodules/clients/dealType/store/models';
import { IDealType } from 'shared/models/DealType';

export const createDealType = createRequestActions<ICreateDealTypePayload, IDealType>(
    RequestType.Create,
    'DEAL_TYPE',
    'settings/');
